import { rest } from 'msw';
import { formatApiPath } from '@/api/utils';
import { DEFAULT_MOCK_VERSION_RESPONSE, VERSION_PATH } from './version.constants';
var versionUrl = formatApiPath(VERSION_PATH);
export var mockGetVersionHander = rest.get(versionUrl, function (req, res, ctx) { return res(ctx.status(200), ctx.json(DEFAULT_MOCK_VERSION_RESPONSE)); });
